import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch'
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import { BootstrapVueIcons } from 'bootstrap-vue'

// Enhanced script loading error handler - add this early in main.js
window.addEventListener('error', (event) => {
  // Handle script tag loading failures (your main issue)
  if (event.target && event.target.tagName === 'SCRIPT' && event.target.src) {
    console.error('[APP] Script loading failed:', event.target.src);
    console.log('[APP] This is likely due to stale cache after deployment');

    // Force reload with cache busting
    const url = new URL(window.location);
    url.searchParams.set('_cb', Date.now());
    url.searchParams.set('_src', 'script_error');
    window.location.replace(url.toString());
    return;
  }

  // Handle chunk loading errors
  if (event.message &&
    (event.message.includes('Loading chunk') ||
      event.message.includes('ChunkLoadError'))) {
    console.warn('[APP] Chunk load error detected:', event.message);
    handleStaleCache('chunk_error');
  }
});

// Enhanced unhandled rejection handler
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message &&
    (event.reason.message.includes('Loading chunk') ||
      event.reason.message.includes('ChunkLoadError') ||
      event.reason.message.includes('Loading CSS chunk'))) {
    console.warn('[APP] Unhandled rejection due to chunk loading:', event.reason.message);
    handleStaleCache('chunk_rejection');
  }
});

// Centralized stale cache handler
async function handleStaleCache(source) {
  console.log(`[APP] Handling stale cache from: ${source}`);

  try {
    // Try to update service worker first
    const reg = await navigator.serviceWorker.getRegistration();
    if (reg) {
      console.log('[APP] Attempting to update service worker...');
      await reg.update();

      if (reg.waiting) {
        console.log('[APP] Found waiting service worker, activating...');
        reg.waiting.postMessage({ type: 'SKIP_WAITING' });

        // Wait for activation then reload
        reg.waiting.addEventListener('statechange', (e) => {
          if (e.target.state === 'activated') {
            console.log('[APP] New SW activated. Reloading...');
            forceReload(source);
          }
        });
        return;
      }
    }
  } catch (e) {
    console.error('[APP] Error updating service worker:', e);
  }

  // Fallback: force reload immediately
  forceReload(source);
}

function forceReload(source) {
  const url = new URL(window.location);
  url.searchParams.set('_cb', Date.now());
  url.searchParams.set('_src', source);
  console.log(`[APP] Force reloading due to ${source}:`, url.toString());
  window.location.replace(url.toString());
}



//Bootstrap icons
Vue.use(BootstrapVueIcons)

//Mask filter
import VueMask from 'v-mask'
Vue.use(VueMask);

// Amplify setup
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import awsconfig from './aws-exports'
Amplify.configure(awsconfig)
Vue.use(AmplifyPlugin, AmplifyModules)

// Axios
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

//Signature
import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);

// router setup
import router from './routes/router';
import i18n from './i18n';
import './registerServiceWorker'
import twinSrc from './directives/twinSrc'
Vue.directive('twin-src', twinSrc)
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  i18n
});
